import { InstagramPostDTO } from 'infrastructure/dtos/instagramPost';
import { BaseApi } from '../base/BaseApi';
import { type IInstagramApi } from './IInstagramApi';
import { CreativeResponseDTO } from 'infrastructure/dtos/creative';
import { ApiRoutes } from '../routes';
import { MediaUpdateDTO } from 'infrastructure/dtos/instagramPost/requests';

export class InstagramApi extends BaseApi implements IInstagramApi {
  public async getInstagramPostsByUserId({ userId }: { userId: string }): Promise<{
    posts: InstagramPostDTO[];
    user: CreativeResponseDTO;
  }> {
    return await this.callApi(ApiRoutes.Instagram.InstagramPostsByUserId, { userId });
  }

  public async instagramPostsAdminAction(body: {
    posts: {
      id: string;
      action: 'publish' | 'reject';
      category_id: string;
      reason?: string;
    }[];
  }): Promise<unknown> {
    return await this.callApi(ApiRoutes.Instagram.InstagramPostAdminAction, body);
  }

  public async instagramMediaUpdate(body: MediaUpdateDTO): Promise<unknown> {
    return await this.callApi(ApiRoutes.Instagram.InstagramMediaUpdate, body);
  }
}
